import {z} from 'zod';

export const redriveErrorResponseSchema = z.object({
  status: z.string(),
  message: z.string(),
  timestamp: z.string(),
});
